import { call, put } from 'redux-saga/effects';
import { api, notify } from 'services';
import { requestErrorHandler } from 'utils';
import {
  UploadVaccineCertificateActions,
  UploadVaccineCertificateRequest,
} from 'store/ducks/drivers';

export function* uploadVaccineCertificate(action: any) {
  const { postData, onSuccess }: UploadVaccineCertificateRequest = action;

  try {
    const { data } = yield call(
      api.post,
      `/vaccine/upload-certificate`,
      postData
    );
    onSuccess && onSuccess(data);
    yield put(UploadVaccineCertificateActions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = requestErrorHandler(error);

    notify('error', errorMessage);

    yield put(
      UploadVaccineCertificateActions.failure(errorMessage, validationErrors)
    );
  }
}
